/**
 * ApiResultCard — claude-api skill 结果卡片
 *
 * 展示 API 调用结果：代码示例、返回内容、Token 统计。
 */

import { memo, useState } from 'react'
import { ChevronRight, Code, Coins, MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'
import './result-cards.less'

interface ApiResult {
  code?: string
  output?: string
  tokensInput?: number
  tokensOutput?: number
  error?: string
  summary?: string
}

export const ApiResultCard = memo(function ApiResultCard({
  result,
}: {
  result: ApiResult
}) {
  const [showCode, setShowCode] = useState(false)
  const hasTokens = result.tokensInput !== undefined || result.tokensOutput !== undefined

  return (
    <div className="flex flex-col gap-2">
      {result.summary && (
        <span className="text-[0.75rem] text-muted-foreground/70">{result.summary}</span>
      )}

      {result.error && (
        <div className="result-card result-card--error">
          <span className="text-[0.75rem] text-destructive/80">{result.error}</span>
        </div>
      )}

      {result.output && (
        <div className="result-card__output">
          <div className="result-card__output-header">
            <MessageSquare />
            <span>API 返回</span>
          </div>
          <pre className="result-card__output-pre">{result.output}</pre>
        </div>
      )}

      {hasTokens && (
        <div className="flex items-center gap-3 pl-0.5">
          <Coins className="h-3 w-3 text-muted-foreground/40 shrink-0" />
          {result.tokensInput !== undefined && (
            <span className="text-[0.65rem] text-muted-foreground/50">
              输入 <span className="font-mono text-foreground/60">{result.tokensInput.toLocaleString()}</span> tokens
            </span>
          )}
          {result.tokensOutput !== undefined && (
            <span className="text-[0.65rem] text-muted-foreground/50">
              输出 <span className="font-mono text-foreground/60">{result.tokensOutput.toLocaleString()}</span> tokens
            </span>
          )}
        </div>
      )}

      {result.code && (
        <>
          <button
            className="flex items-center gap-1 text-[0.7rem] text-primary/60 hover:text-primary/80 transition-colors w-fit"
            onClick={() => setShowCode(!showCode)}
            type="button"
          >
            <ChevronRight className={cn(
              'h-3 w-3 transition-transform duration-200',
              showCode && 'rotate-90',
            )} />
            <Code className="h-3 w-3" />
            <span>{showCode ? '收起代码' : '查看代码示例'}</span>
          </button>
          {showCode && (
            <div className="result-card__code-wrap">
              <pre className="result-card__code">{result.code}</pre>
            </div>
          )}
        </>
      )}
    </div>
  )
})
